<div
  class="container"
  fxLayout="row wrap"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
>
  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYER_ID" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{
      "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate
    }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYER_DFSP_NAME" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYEE_ID" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.TRANSACTION_ID" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.STATUS" | translate }}</mat-label>
    <mat-select>
      <ng-container>
        <mat-option> </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.AMOUNT" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.CURRENCY" | translate }}</mat-label>
    <input matInput />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{
      "TRANSACTIONS.TRANSACTION_DATE_FROM" | translate
    }}</mat-label>
    <input matInput />
    <!-- <input matInput [ngxMatDatetimePicker]="requesttopayDateFromPicker" placeholder="Choose a date"
       [min]="minDate" [max]="maxDate">
    <mat-datepicker-toggle matSuffix [for]="requesttopayDateFromPicker"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #requesttopayDateFromPicker [showSpinners]="true" [showSeconds]="true"
       [stepHour]="1" [stepMinute]="1" [stepSecond]="1">
    </ngx-mat-datetime-picker> -->
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.TRANSACTION_DATE_TO" | translate }}</mat-label>
    <input matInput />
    <!-- <input matInput [ngxMatDatetimePicker]="requesttopayDateToPicker" placeholder="Choose a date"
       [min]="minDate" [max]="maxDate" >
    <mat-datepicker-toggle matSuffix [for]="requesttopayDateToPicker"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #requesttopayDateToPicker [showSpinners]="true" [showSeconds]="true"
       [stepHour]="1" [stepMinute]="1" [stepSecond]="1">
    </ngx-mat-datetime-picker> -->
  </mat-form-field>
</div>

<div class="container">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="startedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.START_TIME_UTC" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ formatDate(requestToPay.startedAt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="completedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.COMPLETED_TIME_UTC" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ formatDate(requestToPay.completedAt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="transactionId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.TRANSACTION_ID" | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let requestToPay"
          matTooltip="{{ requestToPay.transactionId }}"
        >
          {{ shortenValue(requestToPay.transactionId) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerPartyId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.PAYER_ID" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payerPartyId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payeePartyId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.PAYEE_ID" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payeePartyId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerDfspId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payerDfspId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerDfspName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.PAYER_DFSP_NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ displayDfspName(getDfpsEntry(requestToPay.payerDfspId)) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.AMOUNT" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.amount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.CURRENCY" | translate }}
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.currency }}
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TRANSACTIONS.STATE" | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let requestToPay"
          [ngClass]="{
            red: requestToPay.state === 'FAILED',
            green: requestToPay.state === 'ACCEPTED',
            orange: requestToPay.state === 'IN_PROGRESS'
          }"
        >
          {{ requestToPay.state }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="[row.workflowInstanceKey]"
        class="select-row"
      ></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
